import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF, optimizado para leer en el celular en la cancha o imprimir en A4.'
}, {
  q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
  a: 'Sirve para los dos. Si sos nuevo: te da la estructura que ninguna formación te enseñó. Si tenés experiencia: te ahorra las horas de planificación que hoy gastás improvisando.'
}, {
  q: '¿Los 6 Bonus están en las dos opciones?',
  a: 'Sí. Los 6 Bonus están incluidos en ambos packs sin costo adicional. La diferencia del Megapack Elite son los 2 Ebooks de rentabilidad.'
}, {
  q: '¿Qué diferencia hay con otros materiales de tenis que ya existen?',
  a: 'Tenis 360 es el único sistema diseñado específicamente para el contexto de los clubes argentinos: canchas de polvo de ladrillo, alumnos con poco tiempo, grupos mixtos y la realidad económica del profesor independiente. No es traducción de manuales europeos ni clips de Instagram sin hilo conductor.'
}, {
  q: '¿Sirve para niveles mezclados en el mismo grupo?',
  a: 'Sí. El Bonus 5 (Kit de Supervivencia) tiene un protocolo específico para grupos mixtos con el Sistema de Roles, que le permite a cada alumno trabajar en su nivel dentro de la misma clase.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si no es lo que esperabas, escribís un mensaje y te devolvemos el 100% sin preguntas ni formularios.'
}, {
  q: '¿Vale la pena el Megapack Elite si ya planifico bien mis clases?',
  a: 'Si ya planificás bien las clases pero seguís cobrando por clase asistida y no tenés grupos estructurados, los 2 Ebooks Elite son exactamente lo que te falta. Es el salto de "buen profe" a "negocio de tenis rentable".'
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas de crédito y débito a través de Mercado Pago, además de transferencia bancaria.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-offwhite" data-id="element-81">
      <div className="max-w-3xl mx-auto px-4" data-id="element-82">
        <h3 className="text-3xl md:text-4xl font-display text-center text-charcoal mb-12" data-id="element-83">
          Preguntas Frecuentes
        </h3>

        <div className="space-y-4" data-id="element-84">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-85">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" data-id="element-86">
                <span className="font-bold text-charcoal pr-4" data-id="element-87">{faq.q}</span>
                <ChevronDownIcon className={`text-gray-400 shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-88" />
              </button>

              <AnimatePresence data-id="element-89">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-90">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-91">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}